import { render, staticRenderFns } from "./PuntOmplirQuartos.vue?vue&type=template&id=18c90d45&scoped=true"
import script from "./PuntOmplirQuartos.vue?vue&type=script&lang=js"
export * from "./PuntOmplirQuartos.vue?vue&type=script&lang=js"
import style0 from "./PuntOmplirQuartos.vue?vue&type=style&index=0&id=18c90d45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c90d45",
  null
  
)

export default component.exports